import { createContext } from 'preact';

export const ECardGlobalState = createContext({
    selectedRecipient: {
        get: undefined,
        set: undefined,
    },
    currentStep: {
        get: undefined,
        set: undefined,
    },
    isScheduled: {
        get: undefined,
        set: undefined,
    },
    isValidCsv: {
        get: undefined,
        set: undefined,
    },
    recipientsCsvError: {
        get: undefined,
        set: undefined,
    },
    setMaxRecipientsVisible: {
        get: undefined,
        set: undefined,
    },
    isGtmCard: false,
    ecardCategory: {
        get: undefined,
        set: undefined,
    },
    ecardDesignName: {
        get: undefined,
        set: undefined,
    },
});

